import { APIv2 } from './resourcesv2'

export default {
  getPartners: () => {
    return APIv2.get('/partners')
  },
  getPartner: (partnerName) => {
    return APIv2.get(`/partners/${partnerName}`)
  },
  createPartnerPageInfo: (partnerId, { name, title, description, imageUrl }) => {
    return APIv2.post(`/partners/${partnerId}/page-info`, {
      name, title, description, imageUrl
    })
  },
  getPartnerPageInfo: (partnerId) => {
    return APIv2.get(`/partners/${partnerId}/page-info`)
  },
  updatePartnerPageInfo: (partnerId, { name, title, description, imageUrl }) => {
    return APIv2.put(`partners/${partnerId}/page-info`, { name, title, description, imageUrl }, {
      params: { name }
    })
  },
  deletePartnerPageInfo: (partnerId, name) => {
    return APIv2.delete(`partners/${partnerId}/page-info`, {
      params: { name }
    })
  }
}
